export const VALIDATE_OALT_CART_MUTATION = `
mutation OrderMutation($payload: LastOrderPayloadDtoInputType!) {
  orderAsLastTimeValidateCart(payload: $payload) {
    data {
      valid
      freeDeliveryOptionFlag
      paymentInfo{
        paymentId
        paymentGroups
        paypalTokenAvailable
      }
      cart {
        cartId
        pricesSummary {
          vat
          priceItemSummary
          priceDelivery
          pricePayment
          priceProductsSummary
          discountWithoutDelivery
        }
      }
    }
  }
}
`;
